import { Component, ElementRef, OnInit } from '@angular/core';
import { MenuService } from '../../services/menu.service';
import { MatDialog } from '@angular/material';
import { ChangePassDialogComponent } from '../dialogs/change-pass-dialog/change-pass-dialog.component';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-home-component',
  templateUrl: './home.component.html'
})

export class HomeComponent implements OnInit, IFilterComponent {
    constructor(private menuService: MenuService,
                private authService: AuthService,
                private router: Router,
                private filterRecordService: FilterRecordService,
                private dialog: MatDialog) {
      this.menuService.setMenuTitle('', '');
    }
  formElement: ElementRef<any>;
  form: FormGroup;

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "HomeComponent",
      this.form,
    );
  }


  setFilters(): boolean {
   return this.filterRecordService.setFilters(
      "HomeComponent",
      this.form,
    );
  }

  getSearchFilters(): SearchFilter[] {
    return [];
  }

  search(): Promise<any> {
    return Promise.resolve();
  }

  ngOnInit(): void {

    // if ( this.authService.changePassRequired() ) {
    //   this.dialog.open( ChangePassDialogComponent, {
    //     width: '50%',
    //     disableClose: true
    //   });
    // }

    if (this.authService.isExtraccionistaModality()) {
      this.router.navigate(['/extraccionista-search'])
    }

  }
}
